<template>
  <div :class="['result-status', type]">
    <svg-icon
      :name="icon"
      :style="{ fontSize: size }"
      class-name="status-icon"
    />

    <p v-if="title" class="result-text">{{ title }}</p>
  </div>
</template>

<script>
// 结果状态的icon和文案展示组件
const TYPE = {
  success: 'success',
  fail: 'fail'
}

export default {
  name: 'ResultStatus',
  props: {
    // 类型 只有成功失败两种
    type: {
      type: String,
      validator (value) {
        return TYPE[value]
      },
      required: true
    },

    title: {
      type: String,
      default: ''
    },

    size: {
      type: String,
      default: '120px'
    }
  },

  computed: {
    icon () {
      return {
        [TYPE.success]: 'success-face',
        [TYPE.fail]: 'field-face'
      }[this.type]
    }
  }
}
</script>

<style scoped lang="scss">
.result-status {
  text-align: center;
  color: #333;
  font-size: 32px;

  .status-icon {
    display: inline-block;
  }

  .result-text {
    margin-top: 40px;
    color: #333;
    font-size: 32px;
  }

  &.success {
    color: #07c160;
  }

  &.fail {
    color: #fa5151;
  }
}
</style>
